import actionTypes from "../actionTypes";
import IAction from "../../types/IAction";
import { errorNotification, ERROR } from "../../utils/notifications";
import { readMessageBack } from "../../utils/readMessageBack";
import { PaymentComplementReportRow } from "../../types/PaymentComplementReport";

interface State {
  report: PaymentComplementReportRow[];
  searching: boolean;
}

const initialState: State = {
  report: [],
  searching: false
};

export default function paymentComplementReport(
  state: State = initialState,
  action: IAction
): State {
  switch (action.type) {
    case `${actionTypes.GET_PAYMENT_COMPLEMENT_REPORT}_PENDING`: {
      return {
        ...state,
        report: [],
        searching: true
      };
    }
    case `${actionTypes.GET_PAYMENT_COMPLEMENT_REPORT}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        ...state,
        report: [],
        searching: false
      };
    }
    case `${actionTypes.GET_PAYMENT_COMPLEMENT_REPORT}_FULFILLED`: {
      return {
        ...state,
        report: (action.payload && action.payload.data) || [],
        searching: false
      };
    }
    default: {
      return state;
    }
  }
}

export { initialState };
